module.exports = __webpack_public_path__ + "static/media/rsz_bankett-006.a9242d9e.jpg";